import type { User } from '@/globalTypes/user';
import FetchServicesCustomErrors from './BaseFetch';

export default function fetchCurrentUser(): Promise<User> {
  const endpoint = `${import.meta.env.REACT_APP_API_SERVER}/api/v1/user`;
  return FetchServicesCustomErrors({ endpoint });
}
